import React from 'react'
import styled from 'react-emotion'
import { connect } from 'react-redux'
import { ModalV2, Dialog, Button, Checkbox, color } from 'stylist'
import TriggerButton from './TriggerButton'
import QuestionCounts from './QuestionCounts'

const DialogBody = styled(Dialog)`
  color: ${color('slate')};
  width: 432px;
  padding-left: 19px;
  padding-right: 19px;

  ${Dialog.Body}, header, ${Dialog.Footer} {
    padding-left: 0;
    padding-right: 0;

    h4 {
      font-size: 16px;
      font-weight: bold;
    }

    p.unstructuredText {
      margin-top: 6px;
      margin-left: 38px;
      font-style: italic;
    }
  }


  ${Dialog.Footer} {
    margin-top: 28px;
    border-top: 1px solid ${color('paleGrey')};

    button {
      float: right;
    }
  }
`

const ExcludeUnidentifiedCheckboxContainer = styled.div`
  margin-top: 38px;
  label {
    font-size: 14px;
    font-weight: normal;
  }
`
const ExcludeUnidentifiedCheckbox = props => {
  return (
    <ExcludeUnidentifiedCheckboxContainer>
      <Checkbox {...props} />
    </ExcludeUnidentifiedCheckboxContainer>
  )
}

class ConfirmationModal extends React.Component {
  state = {
    excludeUnidentified: true
  }

  toggleExcludeUnidentified = ev => {
    this.setState({
      excludeUnidentified: !this.state.excludeUnidentified
    })
  }

  onShow = (ev, show) => {
    this.setState(
      {
        excludeUnidentified: true
      },
      () => {
        show(ev)
      }
    )
  }

  render() {
    return (
      <ModalV2
        render={({ hide }) => (
          <DialogBody size="sm">
            <Dialog.Header onClose={hide}>
              <Dialog.Title>Are you sure you want to proceed?</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <p>
                Your formatted questions are ready to be imported into our
                survey editor.
              </p>
              <QuestionCounts
                identified={this.props.identified}
                unidentified={this.props.unidentified}
              />
              {this.props.unidentified ? (
                <p className="unstructuredText">
                  Unidentified content will not be shown to respondents.
                </p>
              ) : null}
              <ExcludeUnidentifiedCheckbox
                id="exclude-unidentified"
                label={'Exclude all "unidentified" content'}
                checked={this.state.excludeUnidentified}
                onChange={this.toggleExcludeUnidentified}
              />
            </Dialog.Body>
            <Dialog.Footer>
              <Button kind="ghost" onClick={hide}>
                Go back to review
              </Button>
              <Button
                kind="primary"
                onClick={() =>
                  this.props.saveSurvey({
                    force: true,
                    excludeUnidentified: this.state.excludeUnidentified
                  })
                }
              >
                Proceed to survey editor
              </Button>
            </Dialog.Footer>
          </DialogBody>
        )}
      >
        {({ show }) => <TriggerButton show={ev => this.onShow(ev, show)} />}
      </ModalV2>
    )
  }
}

const mapStateToProps = state => {
  return state.surveyMeta.counts
}

export default connect(mapStateToProps)(ConfirmationModal)



// WEBPACK FOOTER //
// ./src/components/Editor/ConfirmationModal/index.js